export enum languageTypesEnum {
    REQUEST = 'FETCH_LANGUAGE_REQUEST',
    SUCCESS = 'FETCH_LANGUAGE_SUCCESS',
    FAILURE = 'FETCH_LANGUAGE_FAILURE',
  }